import router from '@/router/index';
import { getUnixTimestamp } from '@/plugins/Utils';
import { ClientLogsApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';

export default {
	state: {
		logs: [],
		pageHistory: [],
		modalHistoryStack: [],
	},
	getters: {
		getLogs(state) {
			return state.logs;
		},
		/**
		 * Returns the possible back route. The last entry is the current route
		 * @param state
		 */
		getBackRouteFromModalHistory(state) {
			return state.modalHistoryStack.length > 1 ? state.modalHistoryStack[state.modalHistoryStack.length - 2] : null;
		},
		getModalHistory(state) {
			return state.modalHistoryStack;
		},
	},
	mutations: {
		clearLogs(state) {
			state.logs = [];
		},
		popModalHistory(state) {
			state.modalHistoryStack.pop(); // remove current route
			state.modalHistoryStack.pop(); // remove replacing route, the Modal will add it again
		},
		addModalHistory(state, history) {
			state.modalHistoryStack.push(history);
		},
		addLog(state, payload) {
			state.logs.push({
				message: payload,
				current_route: {
					fullPath: router.currentRoute.fullPath,
					meta: router.currentRoute.meta,
					params: router.currentRoute.params,
				},
				user_agent: navigator.userAgent,
				time: getUnixTimestamp(),
				history: state.pageHistory,
			});
		},
		addHistory(state, history) {
			state.pageHistory.push({
				fullPath: history.fullPath,
				meta: history.meta,
				params: history.params,
			});
		},
	},
	actions: {
		clearModalHistory({ state }) {
			state.modalHistoryStack = [];
		},
		reportLogs({ commit, dispatch, getters }) {
			ClientLogsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.clientLogsPost(getters.getLogs)
				.then(() => {
					commit('clearLogs');
				});
		},
	},
};
